















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import DiceView from '@/components/DiceView.vue';
import {WorkStation} from '@/classes/WorkStation';

export enum FlowDirection {
    LeftToRight = 'left-to-right',
    RightToLeft = 'right-to-left',
    TopToBottom = 'top-to-bottom',
    BottomToTop = 'bottom-to-top',
}

@Component({components: {DiceView}})
export default class WorkstationView extends Vue {
    @Prop() protected id!: number;
    @Prop() protected workstation!: WorkStation;
    @Prop({default: FlowDirection.LeftToRight}) protected flowDirection!: FlowDirection;

    protected isDraggingOver: boolean = false;

    protected handleDrop(payload: any): void {
        this.isDraggingOver = false;
        if (!payload) {
            return;
        }

        this.$emit('drag-drop', {
            sourceId: payload.sourceId,
            destinationId: this.id,
        });
    }

    protected get backgroundArrow(): string {
        const BASE_URL: string = `https://res.cloudinary.com/felipeflor/image/upload`;
        const ANGLE: number = {
            'top-to-bottom': 0,
            'right-to-left': 90,
            'bottom-to-top': 180,
            'left-to-right': 270,
        }[this.flowDirection];

        return `background-image: url('${BASE_URL}/a_${ANGLE}/v1555784793/down-arrow.png')`;
    }

    protected get inputBallsCount(): number {
        if (this.workstation.input === Infinity) {
            return 0;
        }

        return this.workstation.input;
    }

    protected get inputColour(): string {
        if (this.workstation.isHeavilyUnderstaffed) {
            return `background-color: hsl(15, 100%, 66%);`;
        }

        if (this.workstation.isUnderStaffed) {
            return `background-color: hsl(39, 100%, 85%)`;
        }

        return `background-color: hsl(123, 100%, 85%)`;
    }

    protected get reverse(): boolean {
        return this.flowDirection === FlowDirection.RightToLeft;
    }
}
